import { cn } from '#/shared/lib/utils'

import { AVATAR_TONE } from '../model/types'
import type { AvatarTone } from '../model/types'

const TONE_CLASSES: Record<AvatarTone, string> = {
  blue: 'bg-blue-50 text-blue-900',
  green: 'bg-green-50 text-green-600',
  orange: 'bg-orange-100 text-orange-500',
  red: 'bg-red-50 text-red-500',
  gray: 'bg-gray-100 text-gray-500',
}

function pickToneFromId(id: string): AvatarTone {
  const tones: AvatarTone[] = [
    AVATAR_TONE.blue,
    AVATAR_TONE.green,
    AVATAR_TONE.orange,
    AVATAR_TONE.red,
  ]
  let hash = 0
  for (const ch of id) hash = (hash * 31 + ch.charCodeAt(0)) | 0
  return tones[Math.abs(hash) % tones.length]
}

interface ActivityHistoryAvatarProps {
  initials: string
  tone?: AvatarTone
  fallbackId?: string
  className?: string
}

export function ActivityHistoryAvatar({
  initials,
  tone,
  fallbackId,
  className,
}: ActivityHistoryAvatarProps) {
  const resolvedTone =
    tone ?? (fallbackId ? pickToneFromId(fallbackId) : AVATAR_TONE.gray)
  return (
    <div
      className={cn(
        'flex size-7 shrink-0 items-center justify-center overflow-hidden rounded-full text-xs font-medium',
        TONE_CLASSES[resolvedTone],
        className,
      )}
    >
      {initials}
    </div>
  )
}
